import React from 'react';
import cs from 'classnames';
import { loaderDataHooks } from './Loader.dataHooks';
import s from './Loader.scss';

interface LoaderProps {
  dataHook?: string;
  isLoading: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ dataHook, isLoading }) => (
  <div
    className={cs(s.loader, { [s.loading]: isLoading })}
    data-hook={cs(dataHook, loaderDataHooks.root({ isLoading }))}
  >
    <span className={s.spinner}></span>
  </div>
);
